import { useSelector } from 'react-redux';
import { isInBreakoutRoom } from '../breakout-rooms/functions';
import ClosedCaptionButton from './components/web/ClosedCaptionButton';
import { areClosedCaptionsEnabled } from './functions.any';
const cc = {
    key: 'closedcaptions',
    Content: ClosedCaptionButton,
    group: 2
};
/**
 * A hook that returns the CC button if it is enabled and undefined otherwise.
 *
 * @returns {Object | undefined}
 */
export function useClosedCaptionButton() {
    const _areClosedCaptionsEnabled = useSelector(areClosedCaptionsEnabled);
    const _isInBreakoutRoom = useSelector((state) => isInBreakoutRoom(state));
    if (!_areClosedCaptionsEnabled || _isInBreakoutRoom) {
        return undefined;
    }
    return cc;
}
